import * as React from 'react'
import styled, { css } from 'styled-components'
import Lottie from 'react-lottie'
// import loadImage from 'blueimp-load-image'

import Avatar from '../Avatar/Avatar'
import ActionButton from '../ActionButton/ActionButton'
import ImageCropUpload from '../ImageCropUpload/ImageCropUpload'
import readImage from '../../../services/binaries/readImage'

import * as cannonConfetti from '../../../services/data/cannonConfetti.json'
// import loadImageLoader from '../../../services/binaries/loadImageLoader'
import loadImageWithMeta from '../../../services/binaries/test/load-image-meta'
import loadImageWithScale from '../../../services/binaries/test/load-image-scale'
import loadImageOrientation from '../../../services/binaries/test/load-image-orientation'

// import loadImage from '../../../services/binaries/loadImage'

const UploadWrapper = styled.div`
  overflow: hidden;
`

const Base = styled.label`
  cursor: pointer;
  color: var(--color-primary);
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  text-decoration: underline;
  text-align: center;
  display: inline-block;

  &:hover {
    color: var(--color-primary-hover);
  }
`

const StyledUploadInput = styled.input`
  position: absolute;
  top: -999999%;
  left: -999999%;
`

const UploadLabel = styled.label`
  cursor: pointer;
  display: block;
  margin-top: 1rem;
  color: var(--color-primary);
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  margin-bottom: 4.5rem;
`

const StyledImageCropUpload = styled(ImageCropUpload)`
  width: 7.5rem;
  height: 7.5rem;
`

const AvatarContainer = styled.div`
  position: relative;
  margin-top: 1rem;
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 7.5rem;

  ${props =>
    props.hasBackground &&
    css`
      background-color: var(--color-primary);
      padding: 0.5rem;
    `}
`

const StyledAvatar = styled(Avatar)`
  width: 100%;
  height: 100%;
  color: inherit;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
`

const SuccessTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: var(--font-weight-bold);
`

const SuccessMessage = styled.p`
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
`

const lottieOptions = {
  loop: false,
  autoplay: true,
  animationData: cannonConfetti.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

class AvatarUpload extends React.Component {
  constructor(props) {
    super(props)
    const { initialValue } = props
    this.state = {
      value: initialValue,
      update: false,
      success: false,
      jsLoaded: false,
    }
    this.input = React.createRef()

    this.handleCrop = this.handleCrop.bind(this)

    // loadImageLoader(() => {
    //   // this.loadImage = window.loadImage
    //   this.setState({ jsLoaded: true })
    // })
  }

  setAvatar = avatar => {
    const { onAvatarUpload } = this.props
    // const { jsLoaded } = this.state

    if (onAvatarUpload) {
      onAvatarUpload(avatar)
    }
    if (this.input.current) {
      import('../../../services/binaries/loadImage')
        .then(module => {
          const newLoader = loadImageOrientation(
            loadImageWithMeta(loadImageWithScale(module.default)),
          )
          newLoader(
            avatar,
            img => {
              const avatarFix = img.toDataURL('image/jpeg')

              this.setState({ value: avatarFix, update: true, success: false })
            },
            {
              meta: true,
              orientation: true,
              canvas: true,
            },
          )
        })
        .catch(error => {})
    }
  }

  handleChange = e => {
    if (e.target.files.length) {
      readImage(e.target, this.setAvatar)
      const { onChange } = this.props
      if (onChange) {
        onChange(e)
      }
    }
  }

  handleCrop(croppedImage) {
    const { onChange, name, onAvatarCrop } = this.props

    this.setState({
      value: croppedImage,
      update: false,
      success: true,
    })

    if (onAvatarCrop) {
      onAvatarCrop(croppedImage)
    }

    onChange({
      target: {
        name,
        value: croppedImage,
      },
    })
  }

  render() {
    const { name, label, showDefaultAvatar } = this.props
    const { value, update, success } = this.state

    return (
      <>
        <UploadWrapper>
          {!!update && (
            <StyledImageCropUpload src={value} onCrop={this.handleCrop} />
          )}
        </UploadWrapper>
        <Base>
          <StyledUploadInput
            id="avatarUpload"
            type="file"
            name={name}
            ref={this.input}
            accept="image/png, image/jpg, image/jpeg, image/gif"
            onChange={this.handleChange}
          />
          {!update && (showDefaultAvatar || value) && (
            <AvatarContainer hasBackground={!value}>
              <StyledAvatar src={value} hasConfetti={!!value && success} />
            </AvatarContainer>
          )}
        </Base>
        {!!success && (
          <>
            <SuccessTitle>Looking great!</SuccessTitle>
            <Lottie
              options={lottieOptions}
              style={{
                position: 'absolute',
                width: '100%',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: -1,
              }}
            />
            <SuccessMessage>
              Thanks for adding a photo. Go ahead and take the next step (or,
              you can also upload another great looking selfie).
            </SuccessMessage>
          </>
        )}
        {!!label && (showDefaultAvatar || value) ? (
          <UploadLabel htmlFor="avatarUpload">{label}</UploadLabel>
        ) : (
          <BlockButton
            type="button"
            variant="primary"
            onClick={() => this.input.current.click()}
          >
            Upload
          </BlockButton>
        )}
      </>
    )
  }
}

AvatarUpload.defaultProps = {
  // TODO: specify default props
}

AvatarUpload.propTypes = {
  // TODO: specify prop types
}

export default AvatarUpload
